import { JSX } from "react";
import { Accordion } from "components/accordion/accordion";
import { Icons } from "components/icons/constants/icons";
import { AccordionStyle } from "components/accordion/accordion";
import { ProviderSummaryRecord } from "models/view-models/providers/provider-summary-record";
import { ProviderEventList } from "./provider-event-list";
import { t } from "utilities/localization/t";
import { EventService } from "utilities/services/events/event-service";
import { ProviderFeeInvoiceService } from "utilities/services/providers/provider-fee-invoice-service";
import "./provider-event-list-accordion.scss";

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const ProviderEventListAccordion = ({
    providerId,
    summary,
}: {
    providerId?: number;
    summary: ProviderSummaryRecord;
}): JSX.Element => {
    // Keep the cancellable service hook mounted when the accordion details close.
    const { list: listEvents } = EventService.useList();
    const { list: listProviderFeeInvoices } = ProviderFeeInvoiceService.useList();

    return (
        <Accordion
            cssClassName="provider-event-list-accordion"
            chevronLeft
            closedChevron={Icons.ChevronRight}
            openChevron={Icons.ChevronDown}
            title={`${summary?.year} (${summary?.totalEvents} Events)`}
            rightContent={
                <span className="provider-event-list-accordion__total">
                    {`${t("totalInvoiced")}: $${(summary.currentInvoiceTotal ?? 0).toFixed(2)}`}
                </span>
            }
            style={AccordionStyle.Inverse}>
            <ProviderEventList 
                providerId={providerId} 
                year={summary.year} 
                listEvents={listEvents} 
                listProviderFeeInvoices={listProviderFeeInvoices} />
        </Accordion>
    );
};

// -------------------------------------------------------------------------------------------------
// #endregion Component
// -------------------------------------------------------------------------------------------------

export default ProviderEventListAccordion;
